import { rolPermission } from "src/models/rol";

export const validateRoles = (roles: rolPermission[], allowedRoles: string[]): boolean => {
  if (!Array.isArray(roles) || !Array.isArray(allowedRoles) || !roles.length || !allowedRoles.length) {
    return false;
  }
  return roles.some(role => allowedRoles.includes(role.id));
};